import React, { useEffect } from 'react';
import './App.css';
import MemorialWall from './components/MemorialWall';

/**
 * Root component of the application
 * @returns {JSX.Element} Rendered App component
 */
function App() {
  // Minimal iframe detection without DOM manipulation
  useEffect(() => {
    // Detect if we're in an iframe
    let isInIframe = false;
    try {
      isInIframe = window !== window.parent;
    } catch (e) {
      // If we get an error, we're in a cross-origin iframe
      isInIframe = true;
    }
    
    // Add a class to the document body if we're in an iframe
    if (isInIframe) {
      document.body.classList.add('in-iframe');
      
      // Detect Safari 
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      if (isSafari) {
        // Just add the class, don't manipulate DOM on every scroll
        document.body.classList.add('safari-iframe');
      }
    }
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <h1 className="sr-only">October 7th Memorial Wall</h1>
      </header>
      <main>
        <MemorialWall />
      </main>
    </div>
  );
}

export default App;